/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var AddressType;
(function (AddressType) {
    AddressType["Bill"] = "Bill";
    AddressType["Correspondence"] = "Correspondence";
})(AddressType || (AddressType = {}));
export function AddressTypeFromJSON(json) {
    return AddressTypeFromJSONTyped(json, false);
}
export function AddressTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function AddressTypeToJSON(value) {
    return value;
}
